/**
 * @file 获取我的排名
 * @author liudy
 * @see http://api.umucdn.cn/project/151/interface/api/2045
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IGetMyRankInput {
    program_id: string;
}

export interface IRankPointInfo {
    rank: number;
    total_points: number;
}

export interface IGetMyRankOutput {
    user_info: IUserBaseInfo;
    rank_arr: IRankPointInfo[];
}

export const getMyRank = (data: IGetMyRankInput): Promise<IResponse<IGetMyRankOutput>> => {
    return fetchData(Api.GET_PROGRAM_MY_RANK, data);
};
